import { create } from 'zustand'
import { RoomType, TableType } from './types'
import { GET } from 'shared/api/GET'
import { consoleError } from 'shared/helpers/consoleError'

const getInitialCaptionsStore = () => ({
  isCaptionsLoading: false,
  isCaptionsLoaded: false,
  roomsList: [],
  tablesList: []
})

export const useCaptionsStore = create<ICaptionsStore>((set, get) => ({
  ...getInitialCaptionsStore(),
  loadCaptions: async () => {
    set(state => {
      return {
        ...state,
        isCaptionsLoading: true
      }
    })
    if (!get().isCaptionsLoaded) {
      try {
        const captions = await GET.captions()
        set(state => {
          return {
            ...state,
            isCaptionsLoaded: true,
            roomsList: captions.rooms,
            tablesList: captions.tables
          }
        })
      } catch (error) {
        consoleError(error)
      } finally {
        set(state => {
          return {
            ...state,
            isCaptionsLoading: false
          }
        })
      }
    }
  }
}))

export interface ICaptionsStore {
  isCaptionsLoading: boolean
  isCaptionsLoaded: boolean
  roomsList: RoomType[]
  tablesList: TableType[]
  loadCaptions: () => void
}
